import { CIRCLE_CLASS, CIRCLE_CONTAINER_CLASS, TRANSITION_CLASS, HIDDEN_CLASS, ANIMATE_CLASS } from './circles.scss';

const HAS_STARTED = 'has-started';
const SHOULD_RESET = 'should-reset';

export const showSelectedCircles = ($circlesContainers, selectedCabin, setup = false) => {

	const $previouslySelectedCircleContainer = setup ? $() : $circlesContainers.not(`.${HIDDEN_CLASS}`);

	const $nextSelectedCircleContainer = $(`.${CIRCLE_CONTAINER_CLASS}--${selectedCabin}`);
	const $otherCircleContainers = $circlesContainers.not(`.${CIRCLE_CONTAINER_CLASS}--${selectedCabin}`);

	// $previouslySelectedCircleContainer.addClass('g_circles--fade');
	
		// on first run
		if (setup) {
			// hide non-selected circle containers
			$otherCircleContainers
				.addClass(HIDDEN_CLASS).css('z-index', 0);

			$nextSelectedCircleContainer
				.find(`.${CIRCLE_CLASS}`)
				// save flag on circles DOM elements to know if it has started animating and if it should reset
				.data({ [HAS_STARTED]: false, [SHOULD_RESET]: false})
		}

		// on click
		else {
			// fade previously selected circles out
			$previouslySelectedCircleContainer
				// add optacity transition so it will fade later
				.addClass(TRANSITION_CLASS)
				// set opacity to 0
				.addClass(HIDDEN_CLASS)
				// send to back
				.css('z-index', 0)

			// prevent already animating circles from repeating
			$previouslySelectedCircleContainer
				.find(`.${CIRCLE_CLASS}`)
				.filter(function () { return $(this).data(HAS_STARTED); })
				.data(SHOULD_RESET, true);

			// prevent not already animating circles from starting
			$previouslySelectedCircleContainer
				.find(`.${CIRCLE_CLASS}`)
				.filter(function () { return !$(this).data(HAS_STARTED); })
				.removeClass(ANIMATE_CLASS);
		}

		// show selected circles instantly
		$nextSelectedCircleContainer
			// remove opacity transition so it will show instantly
			.removeClass(TRANSITION_CLASS);

		// trigger a reflow, flushing the CSS changes
		$nextSelectedCircleContainer[0].offsetHeight;

		$nextSelectedCircleContainer
			// set opacity to 1
			.removeClass(HIDDEN_CLASS)
			// bring to front
			.css('z-index', 1)
			.find(`.${CIRCLE_CLASS}`)
				// remove class and re-add it later (1)
				.removeClass(ANIMATE_CLASS);

		// trigger a reflow, flushing the CSS changes
		$nextSelectedCircleContainer[0].offsetHeight;

		$nextSelectedCircleContainer
			.find(`.${CIRCLE_CLASS}`)
			// save flag on circles DOM elements to know if it has started animating and if it should reset
			.data({ [HAS_STARTED]: false, [SHOULD_RESET]: false})
			// start/repeat circles animation
			.addClass(ANIMATE_CLASS);
};

export const listeAnimationEvents = ($circles) => {

	// handle animation events update
	$circles.each((index, circle) => {

		const $circle = $(circle);

		circle.addEventListener('animationstart', ({ animationName  }) => {

			// there are 2 animations, react only on one of them (scale, arbitrary)
			if (animationName.startsWith('scale-')) {

				// update animation
				if (!$circle.data(HAS_STARTED)) {
					// log
					console.log(`circle ${index} has started`);
					// reset has-started flag
					$circle.data(HAS_STARTED, true);
				}
			}
		});

		circle.addEventListener('animationiteration', ({ animationName  }) => {

			// there are 2 animations, react only on one of them (scale, arbitrary)
			if (animationName.startsWith('scale-')) {

				// cancel animation
				if ($circle.data(SHOULD_RESET)) {
					// log
					console.log(`circle ${index} should reset`);
					// remove animation
					$circle.removeClass(ANIMATE_CLASS);
					// reset should-reset flag
					$circle.data(SHOULD_RESET, false);
				}
			}
		});
	});
};

// (1) Event could be triggered while it should not reset ex:
// cabin 1 select, cabin 1 circle 1 has started animation
// cabin 2 selected, cabin 1 circle flagged as should-repeat
// cabin 1 selected again while cabin 1 circle 1 still animating
// event animationiteration triggers, anim is canceled
// SOLUTION : when selecting back cabin 1, all circles anim need to be resetted